import { gql } from 'apollo-angular';

export const ChangeTacticPrivacyDocument =
  gql(/* GraphQL*/ `mutation changeTacticPrivacy($private: Boolean!,$tacticId: Int!) {
  changeTacticPrivacy(private:$private, tacticId: $tacticId)
}
`);
